import { isExecutive, isReportingManager, type Role } from "@packages/core/session/roles.ts";

export const MANAGER_IMPACT_ACCESS: readonly Role[] = [isReportingManager, isExecutive];
